module.exports = __webpack_public_path__ + "static/media/nepal.d6e5a448.png";